import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import LoadingAnimation from "../components/LoadingAnimation";
export default function ProfilePage() {
  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
const [updating, setUpdating] = useState(false);
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    gender: "",
    dob: "",
    phone: "",
    address: "",
    wallet_amount: 0,
    profile_photo: null,
  });

  const [photoPreview, setPhotoPreview] = useState(null);

  // ----------------------------------------------------
  // LOAD PROFILE DATA
  // ----------------------------------------------------
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) return;

    fetch("https://medical-backend-cgj8.onrender.com/api/user-info/", {
  headers: {
    Authorization: "Bearer " + token,
  },
})
      .then((res) => res.json())
      .then((data) => {
        setProfile({
          name: data.name || "",
          email: data.email || "",
          gender: data.gender || "",
          dob: data.dob || "",
          phone: data.phone || "",
          address: data.address || "",
          wallet_amount: data.wallet_amount || 0,
          profile_photo: data.profile_photo,
        });

        setPhotoPreview(data.profile_photo);
        setLoading(false);
      })
      .catch((err) => {
      console.log("Profile load error:", err);
      setLoading(false);
    });
}, []);

  // ----------------------------------------------------
  // UPDATE PROFILE
  // ----------------------------------------------------
 const handleUpdate = async () => {
if (updating) return;
  setUpdating(true);
  const token = localStorage.getItem("accessToken");
if (!profile.name.trim()) {
  Swal.fire({
    icon: "warning",
    title: "Name Required",
    text: "Please enter your name"
  });
  setUpdating(false);
  return;
}

if (profile.phone.length !== 10) {
  Swal.fire({
    icon: "warning",
    title: "Invalid Phone",
    text: "Enter valid 10 digit number"
  });
  setUpdating(false);
  return;
}
  if (!token) {
    Swal.fire({
      icon: "warning",
      title: "Not Logged In",
      text: "Please login first"
    });
setUpdating(false); 
    return;
  }

  const formData = new FormData();
  formData.append("name", profile.name);
  formData.append("email", profile.email);
  formData.append("gender", profile.gender);
  formData.append("phone", profile.phone);
  formData.append("address", profile.address);

  if (profile.dob) formData.append("dob", profile.dob);
  if (profile.profile_photo instanceof File)
    formData.append("profile_photo", profile.profile_photo);

  try {
    // 🔥 START LOADING
    Swal.fire({
      title: "Updating Profile...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const res = await fetch(
      "https://medical-backend-cgj8.onrender.com/api/update-profile/",
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
        },
        body: formData,
      }
    );

    Swal.close();

    if (!res.ok) {
setUpdating(false);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "Something went wrong. Please try again"
      });

      return;
    }

    Swal.fire({
      icon: "success",
      title: "Profile Updated",
      text: "Your profile has been updated successfully",
      confirmButtonColor: "#16a34a"
    });
setUpdating(false);
  } catch (err) {
    Swal.close();
setUpdating(false);  
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Network error. Please try again"
    });
  }
};
  if (loading) return <LoadingAnimation />;

  return (
    <div style={styles.page}>

      {/* ---------------------- HEADER ---------------------- */}
      <div style={styles.header}>
        <div style={styles.menuIcon} onClick={() => setDrawerOpen(true)}>
          <div style={styles.bar}></div>
          <div style={styles.bar}></div>
          <div style={styles.bar}></div>
        </div>
        <h2 style={styles.headerTitle}>My Profile</h2>
        <div style={{ width: "30px" }}></div>
      </div>

      {/* ---------------------- DRAWER MENU ---------------------- */}
      {drawerOpen && (
        <div style={styles.drawerOverlay} onClick={() => setDrawerOpen(false)}>
          <div style={styles.drawer} onClick={(e) => e.stopPropagation()}>
            <h3 style={styles.drawerHeading}>Menu</h3>

            <p style={styles.drawerItem} onClick={() => window.location.href = "/orders"}>
              🧾 My Orders
            </p>

            <p style={styles.drawerItem} onClick={() => window.location.href = "/offers"}>
              🎁 Offers
            </p>

            <p style={styles.drawerItem}>
              💰 Wallet: ₹{profile.wallet_amount}
            </p>
             <p
  style={styles.drawerItem}
  onClick={() => (window.location.href = "/settings")}
>
  ⚙️ Settings
</p>
            <p style={styles.drawerItem} onClick={() => window.location.href = "/customer-dashboard"}>
              🏠 Home
            </p>
<p style={styles.drawerItem} onClick={() => window.location.href = "/delete-account"}>
              🗑️ Delete The Account
            </p>
            <p style={styles.drawerItem} onClick={() => { 
              localStorage.clear(); 
              window.location.href = "/"; 
            }}>
              🚪 Logout
            </p>
          </div>
        </div>
      )}

      {/* ---------------------- PROFILE CARD ---------------------- */}
      <div style={styles.card}>
        <div style={styles.photoSection}>
          <div style={styles.avatar}>
  {profile.name?.charAt(0)?.toUpperCase() || "U"}
</div>

          
        </div>

        <label style={styles.label}>Full Name</label>
        <input
          value={profile.name}
          onChange={(e) => setProfile({ ...profile, name: e.target.value })}
          style={styles.input}
        />

        <label style={styles.label}>Email</label>
        <input
          type="email"
          value={profile.email}
          onChange={(e) => setProfile({ ...profile, email: e.target.value })}
          style={styles.input}
        />

        <label style={styles.label}>Gender</label>
        <select
          value={profile.gender}
          onChange={(e) => setProfile({ ...profile, gender: e.target.value })}
          style={styles.input}
        >
          <option value="">Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>

        <label style={styles.label}>Date of Birth</label>
        <input
          type="date"
          value={profile.dob}
          onChange={(e) => setProfile({ ...profile, dob: e.target.value })}
          style={styles.input}
        />

        <label style={styles.label}>Phone</label>
        <input
          type="text"
          maxLength="10"
          value={profile.phone}
          onChange={(e) => {
            const val = e.target.value.replace(/\D/g, "");
            setProfile({ ...profile, phone: val });
          }}
          style={styles.input}
        />

        

        <button 
  style={styles.updateBtn} 
  onClick={handleUpdate}
  disabled={updating}
>
  {updating ? "Updating..." : "Update Profile"}
</button>
      </div>
    </div>
  );
}

/* ---------------------- STYLES ---------------------- */

const styles = {
  page: {
    maxWidth: "480px",
    margin: "0 auto",
    paddingBottom: "40px",
    background: "#f5f7fb",
    minHeight: "100vh",
  },

  /* HEADER */
  header: {
    height: "60px",
    background: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 15px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    position: "sticky",
    top: 0,
    zIndex: 20,
  },

  menuIcon: { cursor: "pointer" },

  bar: {
    width: "24px",
    height: "3px",
    background: "#333",
    margin: "4px 0",
    borderRadius: "2px",
  },

  headerTitle: { fontSize: "20px", fontWeight: "600" },

  /* DRAWER */
  drawerOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    background: "rgba(0,0,0,0.4)",
    zIndex: 30,
  },

  drawer: {
    width: "260px",
    background: "white",
    height: "100%",
    padding: "20px",
    boxShadow: "3px 0 8px rgba(0,0,0,0.2)",
  },

  drawerHeading: {
    fontSize: "22px",
    marginBottom: "20px",
    fontWeight: "700",
  },

  drawerItem: {
    padding: "14px 0",
    fontSize: "17px",
    borderBottom: "1px solid #eee",
    cursor: "pointer",
  },

  /* PROFILE CARD */
card: {
  background: "white",
  padding: "25px",   // 🔥 increase from 20 → 25
  margin: "20px",
  borderRadius: "16px",
  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
},

  photoSection: { textAlign: "center", marginBottom: "20px" },

  photo: {
    width: "110px",
    height: "110px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "3px solid #ddd",
    marginBottom: "10px",
  },

  fileInput: { marginTop: "10px" },

  label: { fontWeight: "600", marginBottom: "5px", marginTop: "10px" },

input: {
  width: "100%",
  padding: "12px",
  borderRadius: "10px",
  border: "1px solid #ccc",
  background: "#fafafa",
  marginBottom: "12px",

  maxWidth: "100%",        // keep responsive
  boxSizing: "border-box", // 🔥 important fix
},
  textarea: {
    width: "100%",
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid #ccc",
    height: "70px",
    background: "#fafafa",
  },

  updateBtn: {
    width: "100%",
    padding: "14px",
    background: "#007bff",
    color: "white",
    fontSize: "16px",
    marginTop: "18px",
    borderRadius: "10px",
    border: "none",
    fontWeight: "600",
  },

 avatar: {
  width: "110px",
  height: "110px",
  borderRadius: "50%",
  background: "#2e7dff",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "40px",
  fontWeight: "bold",
  margin: "0 auto 10px"
},
};
